import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {FormBuilder, FormGroup, ValidatorFn} from "@angular/forms";
import {faAngleDoubleRight, faCircle} from "@fortawesome/free-solid-svg-icons";
import {Observable, of, Subscription} from "rxjs";
import {switchMap} from "rxjs/operators";
import {CatalogApiService} from "src/app/api/catalog-api.service";
import {
  Backside,
  Color,
  EnumFeature,
  FixedFeature,
  Lens,
  LensFeature,
  LensFilter,
  Material,
  QueryFilter,
  RangeFeature
} from "src/app/model/catalog/catalog.model";
import {LensSide, LensType} from "src/app/model/configuration/configuration";
import {LensOrderItem} from "src/app/model/order/order";
import {ReturnStoreService} from "src/app/return/return-store.service";
import {GlobalStorageService} from "src/app/service-utils/global-storage.service";
import {i18nService} from "src/app/service-utils/i18n.service";
import {ValidatorService} from "src/app/service-utils/validator-service";
import {CatalogService} from "src/app/utils/catalog.service";
import {MessageService} from "src/app/utils/message/message.service";
import {ResponseViewComponent} from "../../new-order-proposal/response-view/response-view.component";
import {NewOrderStoreService} from "../../new-order-store-service.service";
import {ManufactureApiService} from "../../../api/manufacture-api.service";
import {User} from "../../../auth/auth.model";
import {AuthManagerService} from "../../../auth/auth-manager.service";
import {DateFilterFn} from "@angular/material/datepicker";

@Component({
  selector: 'app-final-lens',
  templateUrl: './final-lens.component.html',
  styleUrls: ['./final-lens.component.scss']
})
export class FinalLensComponent implements OnInit, OnDestroy, OnChanges {
  @Input() side: LensSide;
  @Input() isNotReturn: boolean = true;
  @Input() returnItem: any;
  @Output() copyEmit = new EventEmitter<LensSide>();
  @Output() switchEmit = new EventEmitter<LensSide>();

  lensFilter: LensFilter = {};

  queryFilter: QueryFilter = {
    backSideQuery: {},
    colorQuery: {},
    materialQuery: {},
    familyQuery: {}
  };

  LensSide = LensSide;
  LensType = LensType;
  form: FormGroup;
  lensDetailsForm: FormGroup;
  isIndividual: boolean = false;
  isHard: boolean = true;
  showReturn: boolean = false;
  isReturn: boolean;
  showEase: boolean;
  easeDouble: boolean = true;
  isFirstBackSideFetch: boolean = true;

  filteredBackSide: Observable<Backside[]>;
  filteredLensFamily: Observable<Lens[]>;
  filteredMaterial: Observable<Material[]>;
  filteredColor: Observable<Color[]>;

  responseProposal: { responseView: ResponseViewComponent, lensType: LensType };
  isResponseProposal: boolean = false;

  subscriptions = new Subscription();
  responseTrialLens: any;
  isResponseTrialLens: boolean = false;
  copyTrialLens: LensOrderItem;
  isNeedShowAfterChoice: boolean = false;
  isResponseTrialLensLensFamilySet: boolean = false;
  isResponseTrialLensFirstLensFamily: boolean = false;

  copyFinalLens: LensOrderItem;
  isCopyFinalLens: boolean = false;
  isEditFinalLens: boolean = false;
  indexEditFinalLens: number;

  features: { default?: Array<LensFeature>, individual?: Array<LensFeature> };
  showAdditionalOptions: boolean = false;
  disableAdditionalOptions: boolean = false;

  arrow = faAngleDoubleRight;
  circle = faCircle;

  prevValueCommission: string;

  defaultColor: Color;

  backSideId: number;
  lensFamilyId: number;
  additionalOptions = new Map<string, number>();

  minDate: Date;
  desireDate: Date;
  showDesireDate: boolean = false;
  currentUser: User;
  inRange: boolean = true;
  dateFilter: DateFilterFn<any>;

  constructor(private formBuilder: FormBuilder,
              private i18nService: i18nService,
              private catalogApiService: CatalogApiService,
              private catalogService: CatalogService,
              private validatorService: ValidatorService,
              private newOrderStoreService: NewOrderStoreService,
              private messageService: MessageService,
              private globalStorageService: GlobalStorageService,
              private returnStoreService: ReturnStoreService,
              private manufactureApiService: ManufactureApiService,
              private authManagerService: AuthManagerService) {
    this.currentUser = this.authManagerService.currentUser;
    this.lensFilter.backSides = this.newOrderStoreService.backSides;
    this.lensFilter.families = this.newOrderStoreService.families;
    this.lensFilter.materials = this.newOrderStoreService.materials;
    this.lensFilter.colors = this.newOrderStoreService.colors;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.lensDetailsForm != undefined) {
      Object.keys(this.lensDetailsForm.controls).forEach(feature => {
        if (this.form.controls[feature].enabled && this.form.controls[feature].value != '') {
          this.additionalOptions.set(feature, this.lensDetailsForm.controls[feature].value);
        }
      });
    }
  }

  ngOnInit() {
    this.checkDesireDate();
    this.initForm();
    this.getFilters();
    this.initFiltersHandlers();

    if (this.side === LensSide.RIGHT || !this.isNotReturn) {
      this.newOrderStoreService.responseProposalRight$.subscribe(data => {
        this.responseProposal = data;
        console.log('selectLensTypeFromProposal');
        this.selectLensTypeFromProposal();
      });

      this.subscriptions.add(this.newOrderStoreService.trialLensAllRight$.subscribe(data => {
        this.isNeedShowAfterChoice = true;
        this.isResponseTrialLensLensFamilySet = false;
        this.isResponseTrialLensFirstLensFamily = true;
        this.responseTrialLens = data.trialLens;
        this.copyTrialLens = this.responseTrialLens.copyTrialLens;
        console.log('selectLensTypeFromTrialLens');
        this.selectLensTypeFromTrialLens();
      }));

      if (this.newOrderStoreService.getCopyFinalLensRight()) {
        this.copyFinalLens = this.newOrderStoreService.getCopyFinalLensRight();
        this.copyFormFinalLens();
        this.newOrderStoreService.setCopyFinalLensRight(undefined);
      }
      this.subscriptions.add(this.newOrderStoreService.copyFinalLensRight$.subscribe(data => {
        if (data) {
          this.indexEditFinalLens = -1;
          this.copyFinalLens = data;
          this.copyFormFinalLens();
          this.newOrderStoreService.setCopyFinalLensRight(undefined);
        }
      }));

      if (this.returnStoreService.getItem()) {
        this.copyFinalLens = this.returnStoreService.getItem();
        this.copyFormFinalLens();
      }
      this.subscriptions.add(this.returnStoreService.item$.subscribe(data => {
        if (data) {
          this.indexEditFinalLens = -1;
          this.copyFinalLens = data;
          this.copyFormFinalLens();
        }
      }));

      this.subscriptions.add(this.newOrderStoreService.editFinalLensRight$.subscribe(data => {
        if (data['editFinalLens']) {
          this.copyFinalLens = data['editFinalLens'];
          this.indexEditFinalLens = data['index'];
          this.copyFormFinalLens(true);
        }
      }));
    }

    if (this.side === LensSide.LEFT || !this.isNotReturn) {
      this.newOrderStoreService.responseProposalLeft$.subscribe(data => {
        this.responseProposal = data;
        console.log('selectLensTypeFromProposal');
        this.selectLensTypeFromProposal();
      });

      this.subscriptions.add(this.newOrderStoreService.trialLensAllLeft$.subscribe(data => {
        this.isNeedShowAfterChoice = true;
        this.isResponseTrialLensLensFamilySet = false;
        this.isResponseTrialLensFirstLensFamily = true;
        this.responseTrialLens = data.trialLens;
        this.copyTrialLens = this.responseTrialLens.copyTrialLens;
        console.log('selectLensTypeFromTrialLens');
        this.selectLensTypeFromTrialLens();
      }));

      if (this.newOrderStoreService.getCopyFinalLensLeft()) {
        this.copyFinalLens = this.newOrderStoreService.getCopyFinalLensLeft();
        this.copyFormFinalLens();
        this.newOrderStoreService.setCopyFinalLensLeft(undefined);
      }
      this.subscriptions.add(this.newOrderStoreService.copyFinalLensLeft$.subscribe(data => {
        if (data) {
          this.indexEditFinalLens = -1;
          this.copyFinalLens = data;
          this.copyFormFinalLens();
          this.newOrderStoreService.setCopyFinalLensLeft(undefined);
        }
      }));

      if (this.returnStoreService.getItem()) {
        this.copyFinalLens = this.returnStoreService.getItem();
        this.copyFormFinalLens();
      }
      this.subscriptions.add(this.returnStoreService.item$.subscribe(data => {
        if (data) {
          this.indexEditFinalLens = -1;
          this.copyFinalLens = data;
          this.copyFormFinalLens();
        }
      }));

      this.subscriptions.add(this.newOrderStoreService.editFinalLensLeft$.subscribe(data => {
        if (data['editFinalLens']) {
          this.copyFinalLens = data['editFinalLens'];
          this.indexEditFinalLens = data['index'];
          this.copyFormFinalLens(true);
        }
      }));
    }

    this.form.get('commission').valueChanges.subscribe(value => {
      if (value && value !== this.prevValueCommission) {
        this.prevValueCommission = value;
        this.newOrderStoreService.setCommissionFinalLens(value);
      }
    });

    this.newOrderStoreService.commissionFinalLens$.subscribe(data => {
      this.form.get('commission').setValue(data);
    });

    this.initDateFilter();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private selectLensTypeFromProposal() {
    this.isResponseProposal = true;
    this.isResponseTrialLens = false;
    this.isCopyFinalLens = false;
    this.isEditFinalLens = false;
    this.clearLensFilterForm();
    this.clearQueryFilter();
    this.clearLensDetailsForm();
    this.isHard = this.responseProposal.lensType !== LensType.SOFT;
    this.form.controls['lensType'].setValue(this.responseProposal.lensType);
    this.getFilters(this.isResponseProposal);
  }

  private selectLensTypeFromTrialLens() {
    this.isResponseProposal = false;
    this.isResponseTrialLens = true;
    this.isCopyFinalLens = false;
    this.isEditFinalLens = false;
    this.clearLensFilterForm();
    this.clearQueryFilter();
    this.clearLensDetailsForm();
    this.form.get('commission').setValue(this.copyTrialLens?.commission);
    this.form.controls['lensType'].setValue(LensType.HARD);

    if (this.copyTrialLens?.article?.backSide?.id === this.responseTrialLens?.calculationSection?.data?.backSide?.id) {
      this.form.controls['backSide'].setValue(this.copyTrialLens?.article?.backSide?.name);
      this.selectBackSide(this.copyFinalLens?.article?.backSide);
    } else {
      const backSide = this.responseTrialLens?.calculationSection?.data?.backSide;
      //this.filteredBackSide = of([NONE, backSide]);
      this.form.get('backSide').setValue(backSide.name);
      this.selectBackSide(backSide);
      this.selectFamily();
    }

    if (this.copyTrialLens?.article?.id && this.copyTrialLens?.article?.name) {
      const articleName = this.copyTrialLens?.article?.name;
      const backSideId = this.responseTrialLens?.calculationSection?.data?.backSide.id;
      // find lens for defined backSide
      const lensFamily = this.newOrderStoreService.families.find(f => f.name == articleName && f.backSide == backSideId);
      if (lensFamily != undefined) {
        this.form.controls['lensFamily'].setValue(articleName);
        this.selectFamily(lensFamily);
      } else {
        this.form.controls['lensFamily'].setValue('');
        this.messageService.info("newOrder.trialLens.afterChoice");
      }
    } else {
      if (this.responseTrialLens?.calculationSection?.data?.backSide && this.responseTrialLens?.calculationSection?.data?.material) {
        const families = this.newOrderStoreService.families.filter(lens =>
          lens.backSide == this.responseTrialLens.calculationSection.data.backSide.id &&
          lens.materials.includes(this.responseTrialLens.calculationSection.data.material.id));
        this.filteredLensFamily = of(families.sort((a, b) => a.name.localeCompare(b.name)));
        if (this.isNeedShowAfterChoice) {
          this.messageService.info("newOrder.trialLens.afterChoice");
          this.isNeedShowAfterChoice = false;
        }
      }
    }

    if (this.copyTrialLens?.material?.id === this.responseTrialLens?.calculationSection?.data?.material?.id) {
      this.form.get('material').setValue(this.copyTrialLens?.material?.name);
      this.form.get('color').setValue(this.copyTrialLens?.color?.name);
      this.selectMaterial(this.copyTrialLens?.material);
      this.copyTrialLens.color = undefined;
    } else {
      this.form.get('material').setValue(this.responseTrialLens?.calculationSection?.data?.material?.name);
      this.form.get('color').setValue(this.responseTrialLens?.calculationSection?.data?.material?.defaultColor?.name);
      this.selectMaterial(this.responseTrialLens?.calculationSection?.data?.material);
      if (this.copyTrialLens && this.copyTrialLens.color) {
        this.copyTrialLens.color = undefined;
      }
    }
  }

  private copyFormFinalLens(edit?: boolean) {
    this.isResponseProposal = false;
    this.isResponseTrialLens = false;
    if (this.indexEditFinalLens > -1) {
      this.isCopyFinalLens = false;
      this.isEditFinalLens = true;
    } else {
      this.isCopyFinalLens = true;
      this.isEditFinalLens = false;
    }
    this.form.controls['commission'].setValue(this.copyFinalLens.commission);
    this.form.controls['lensType'].setValue(this.copyFinalLens.article.lensType);
    this.form.controls['lensFamily'].setValue(this.copyFinalLens.article.name);
    this.setTypeLens(LensType.HARD == this.copyFinalLens.article.lensType);
    this.selectFamily({id: this.copyFinalLens.article.id, name: this.copyFinalLens.article.name});
    this.form.controls['material'].setValue(this.copyFinalLens.material.name);
    this.selectMaterial(this.copyFinalLens.material);
    if (edit) {
      this.desireDate = this.copyFinalLens.desireDate;
      this.calculateProductionDate();
    }
  }

  private initForm() {
    this.form = this.formBuilder.group({
      commission: [undefined, [this.validatorService.requiredFieldValidator('Commission')]],
      lensType: [LensType.HARD],
      backSide: [undefined, [this.validatorService.requiredFieldValidator('BackSide')]],
      lensFamily: [undefined, [this.validatorService.requiredFieldValidator('LensFamily')]],
      material: [undefined, [this.validatorService.requiredFieldValidator('Material')]],
      color: [undefined, [this.validatorService.requiredFieldValidator('Color')]],
    });
    this.prevValueCommission = this.form.get('commission').value;
    this.lensDetailsForm = this.formBuilder.group({});
  }

  private initFiltersHandlers() {
    this.form.get('backSide').valueChanges.subscribe(value => {
      this.filterBackSide(value);
    });

    this.form.get('color').valueChanges.subscribe(value => {
      this.filterColor(value);
    });

    this.form.get('lensFamily').valueChanges.subscribe(value => {
      this.filterLensFamily(value);
    });

    this.form.get('material').valueChanges.subscribe(value => {
      this.filterMaterial(value);
    });
  }

  backspaceBackSide() {
    if (this.form.get('backSide').value.trim() === '') {
      this.selectBackSide();
    }
  }

  backspaceLensFamily() {
    if (this.form.get('lensFamily').value.trim() === '') {
      this.selectFamily();
    }
  }

  backspaceMaterial() {
    if (this.form.get('material').value.trim() === '') {
      this.selectMaterial();
    }
  }

  backspaceColor() {
    if (this.form.get('color').value.trim() === '') {
      this.setColor();
    }
  }

  private getFilters(isResponseProposal: boolean = false) {
    this.clearLensFilterForm();
    this.clearQueryFilter();
    this.clearLensDetailsForm();
    this.showReturn = false;
    this.setTypeLens(this.isHard);

    if (isResponseProposal) {
      this.form.controls['lensFamily'].setValue(this.responseProposal.responseView.lensBackSide);
      this.selectFamily();
      this.form.controls['material'].setValue(this.responseProposal.responseView.data.Material);
      this.selectMaterial();
      this.setColor();
    }
  }

  selectBackSide(backSide?: Backside) {
    this.setBackSide(backSide);
    if (backSide != null) {
      const lensType: string = ('' + this.form.get('lensType').value).toLowerCase();
      const families = this.newOrderStoreService.families.filter(f => f.backSide == backSide.id && f.lensType == lensType);
      // if family exists for backside, won't clear it
      const selectedFamily = families.find(family => family.name == this.form.get('lensFamily').value);
      if (selectedFamily) {
        if (selectedFamily.backSide == backSide.id) {
          console.log('matching family left with no changes');
        } else {
          this.form.get('lensFamily').setValue('');
        }
      }
      this.form.get('material').setValue('');
      this.form.get('color').setValue('');
      this.filterLensFamilies(this.backSideId);
    } else {
      this.filterLensFamilies();
    }
  }

  selectFamily(copyLensFamily?: Lens) {
    this.setLensFamily(copyLensFamily);
    if (this.isResponseTrialLens || this.isResponseTrialLensFirstLensFamily) {
      this.isResponseTrialLensFirstLensFamily = false;
    }
    const lensFamily: Lens = copyLensFamily
      ? copyLensFamily
      : this.lensFilter.families.find(lensFamily => lensFamily.name === this.form.get('lensFamily').value);

    if (((this.isCopyFinalLens || this.isEditFinalLens) && this.copyFinalLens?.isIndividual) || this.isResponseTrialLens && this.copyTrialLens?.isIndividual) {
      this.isIndividual = true;
    } else {
      this.isIndividual = false;
    }

    if (lensFamily && lensFamily.name !== NONE.name) {
      const backSideId: number = this.newOrderStoreService.families.find(lens => lens.name == lensFamily.name).backSide;
      const details = this.newOrderStoreService.details.find(details => details.backSideId == backSideId && lensFamily.name == details.name);
      if (details.backSideId) {
        let backSide = this.lensFilter.backSides.find(backSide => backSide.id == details.backSideId);
        if (backSide) {
          this.form.get('backSide').setValue(backSide.name);
          this.backSideId = backSide.id;
          this.filterBackSides(this.isHard);
        }
      }

      this.showEase = lensFamily.name.toLowerCase().includes('ease');

      this.features = details.features;
      if (this.features.individual && this.isIndividual) {
        this.features.individual.sort((a, b) => a.id - b.id);
        this.initLensDetailsForm(this.features.individual);
      } else {
        if (this.features.individual === null) {
          this.isIndividual = false;
        }
        this.features.default.sort((a, b) => a.id - b.id);
        this.initLensDetailsForm(this.features.default);
      }
    }

    this.filterLensFamilies(this.backSideId);
    this.filterMaterials();
  }

  selectMaterial(copyMaterial?: Material) {
    this.setMaterial(copyMaterial);
    this.checkIsNeedShowReturn(copyMaterial);

    if (this.copyFinalLens?.color && copyMaterial) {
      copyMaterial.colors.includes(this.copyFinalLens.color.id)
        ? this.form.get('color').setValue(this.copyFinalLens?.color?.name)
        : this.setColor(this.defaultColor);
    } else if (this.responseTrialLens?.calculationSection?.data?.material?.id !== this.queryFilter?.colorQuery?.materialId && this.lensFilter.colors && this.defaultColor?.name && this.lensFilter.colors.findIndex(color => color.name === this.defaultColor.name) > -1) {
      this.form.get('color').setValue(this.lensFilter.colors[this.lensFilter.colors.findIndex(color => color.name === this.defaultColor.name)].name);
    }

    this.calculateProductionDate();
    this.filterMaterials();
    this.filterColors();
  }

  initLensDetailsForm(features: Array<LensFeature>) {
    let lensDetailsConfig = [];
    features.forEach(feature => {

      let startValue = "";

      if (this.isResponseProposal) {
        let key = Object.keys(this.responseProposal.responseView.form.value).find(key => key === feature.name) || Object.keys(this.responseProposal.responseView.formResponse.value).find(key => key === feature.name);
        if (key) {
          startValue = this.responseProposal.responseView.form.value[key] || this.responseProposal.responseView.formResponse.value[key];
        }
      } else if (this.isResponseTrialLens) {
        let key = undefined;
        if (this.responseTrialLens?.copyTrialLens?.featureValues) {
          key = Object.keys(this.responseTrialLens?.copyTrialLens?.featureValues).find(key => key === feature.name);
          if (key && ((key !== 'Prism' && key !== 'PrismType') || ((key === 'Prism' || key === 'PrismType') && this.responseTrialLens.calculationSection.form.value['additionalOptions'] !== 'none'))) {
            startValue = this.responseTrialLens.copyTrialLens.featureValues[key].toString();
          }
        }
        key = Object.keys(this.responseTrialLens?.trialLensSection?.form.value).find(key => key === feature.name);
        if (key) {
          startValue = this.responseTrialLens?.trialLensSection?.form.value[key].toString();
        }
        key = Object.keys(this.responseTrialLens?.overRefractionSection?.form.value).find(key => key === feature.name);
        if (key) {
          startValue = this.responseTrialLens?.overRefractionSection?.form.value[key].toString();
        }
        key = Object.keys(this.responseTrialLens?.newParameterSection?.form.value).find(key => key === feature.name);
        if (key) {
          startValue = this.responseTrialLens?.newParameterSection?.form.value[key].toString();
        }
        key = Object.keys(this.responseTrialLens?.calculationSection?.form.value).find(key => key === feature.name);
        if (key && ((key !== 'Prism' && key !== 'PrismType') || ((key === 'Prism' || key === 'PrismType') && this.responseTrialLens?.calculationSection?.form.value['additionalOptions'] !== 'none'))) {
          startValue = this.responseTrialLens?.calculationSection?.form.value[key].toString();
        }
      } else if (this.isCopyFinalLens || this.isEditFinalLens) {
        let key = Object.keys(this.copyFinalLens.featureValues).find(key => key === feature.name);
        if (key && this.copyFinalLens.featureValues[key]) {
          startValue = this.copyFinalLens.featureValues[key].toString();
        }
      }

      let validators: Array<ValidatorFn> = [];

      if (feature.required) {
        validators.push(this.validatorService.requiredFieldValidator(feature.name));
      }
      if (feature.type === 'RANGE') {
        validators.push(this.validatorService.numericValidator(feature.name), this.validatorService.rangeValidator(feature as RangeFeature));
      }
      if (feature.type === 'FIXED') {
        lensDetailsConfig[feature.name] = [this.extractFeatureValue(feature), validators];
      } else {
        if (startValue && startValue.toString().charAt(0) === '+') {
          startValue = startValue.substring(1);
        }
        lensDetailsConfig[feature.name] = [startValue, validators];
      }

    });
    features.sort((a, b) => a.id - b.id);
    this.lensDetailsForm = this.formBuilder.group(lensDetailsConfig);

    // fill all previously entered matching values to the newly created form
    Object.keys(this.lensDetailsForm.controls).forEach(key => {
      if (this.additionalOptions.has(key)) {
        this.lensDetailsForm.controls[key].setValue(this.additionalOptions.get(key));
      }
    });

    if (this.isResponseProposal || this.isResponseTrialLens || this.isEditFinalLens || this.isCopyFinalLens) {
      this.initFeaturesState();
      Object.keys(this.lensDetailsForm.controls).forEach(key => {
        if (this.lensDetailsForm.controls[key].value !== "") {
          this.lensDetailsForm.controls[key].markAsTouched();
        }
      })
    }
    // to be able to reset lensDetails values after first loading
    this.isCopyFinalLens = false;
    this.calculateProductionDate();
  }

  toggleIndividual() {
    if (this.isIndividual) {
      this.initLensDetailsForm(this.features.individual);
      this.showAdditionalOptions = true;
      this.disableAdditionalOptions = true;
    } else {
      this.initLensDetailsForm(this.features.default);
      this.showAdditionalOptions = false;
      this.disableAdditionalOptions = false;
    }
  }

  addLensesCheckRequiredFields() {
    Object.keys(this.form.controls).forEach(key => {
      if (!this.form.controls[key].value || this.form.controls[key].value === "" || this.form.controls[key].value === null) {
        this.form.get(key).markAsTouched();
        this.form.get(key).setValue("");
      }
    });

    let features = (this.isIndividual) ? this.features.individual : this.features.default;
    if (features && Object.keys(features).length > 0) {
      features.forEach(feature => {
        if (feature.required && this.lensDetailsForm.get(feature.name).value === "") {
          this.lensDetailsForm.get(feature.name).markAsTouched();
          this.lensDetailsForm.get(feature.name).setValue("");
        }
      });
    }
  }

  private checkIsNeedShowReturn(copyMaterial?: Material) {
    this.showReturn = false;
    let material: Material;
    if (copyMaterial && copyMaterial.name === this.form.get('material').value) {
      material = copyMaterial;
    } else {
      material = this.lensFilter.materials.find(material => material.name === this.form.get('material').value);
    }
    if (material && material.name !== NONE.name && material.return) {
      if (this.isEditFinalLens && this.copyFinalLens) {
        this.isReturn = (this.copyFinalLens.material.id === material.id) ? this.copyFinalLens.isReturn : this.globalStorageService.isReturn;
        this.copyFinalLens.isReturn = this.isReturn;
      } else {
        this.isReturn = this.globalStorageService.isReturn;
      }
      this.showReturn = true;
    } else if (!material?.return) {
      this.isReturn = false;
    }
  }

  setTypeLens(isHard: boolean) {
    this.isHard = isHard;
    const lensType = isHard ? 'HARD' : 'SOFT';
    this.form.get('lensType').setValue(lensType);
    this.form.get('backSide').setValue('');
    this.form.get('lensFamily').setValue('');
    this.form.get('material').setValue('');
    this.form.get('color').setValue('');

    this.filterBackSides(isHard);
    this.filterLensFamilies();
  }

  setBackSide(copyBackSide?: Backside) {
    const backSide = copyBackSide
      ? copyBackSide
      : this.lensFilter.backSides.find(backSide => backSide.name === this.form.get('backSide').value);
    if (backSide) {
      this.backSideId = backSide.id;
      if (backSide.name === NONE.name) {
        this.form.get('backSide').setValue('');
        this.form.get('lensFamily').setValue('');
      } else {
        this.form.get('backSide').setValue(backSide.name);
        // Clear lensFamily if non-present for updated backSide
        const family = this.lensFilter.families.find(f => f.name == this.form.get('lensFamily').value);
        if (family) {
          if (family.backSide != backSide.id) this.form.get('lensFamily').setValue('');
        }
      }
    } else {
      this.form.get('backSide').setValue('');
      this.form.get('lensFamily').setValue('');
    }
    this.filteredBackSide = of(this.lensFilter.backSides);
  }

  setLensFamily(copyLensFamily?: Lens) {
    let lensFamily: Lens;
    if (copyLensFamily && !this.isResponseTrialLens) {
      lensFamily = copyLensFamily;
    } else if (this.isResponseTrialLens && !this.isResponseTrialLensLensFamilySet) {
      this.isResponseTrialLensLensFamilySet = true;
      lensFamily = this.lensFilter.families.find(lensFamily => lensFamily.name.trim().toLowerCase() === this.responseTrialLens?.copyTrialLens?.article?.name.toLowerCase());
      if (!lensFamily) {
        let newLensFamily = undefined;
        if (this.responseTrialLens?.copyTrialLens?.article?.lensGroup &&
          this.responseTrialLens?.calculationSection?.data?.backSide?.name &&
          this.responseTrialLens?.calculationSection?.data?.backSide?.name?.trim().toLowerCase() !== 'sph'.toLowerCase()) {
          newLensFamily = this.responseTrialLens?.copyTrialLens?.article?.lensGroup?.trim() + '-' + this.responseTrialLens?.calculationSection?.data?.backSide?.name?.trim();
        } else if (this.responseTrialLens?.copyTrialLens?.article?.lensGroup &&
          this.responseTrialLens?.calculationSection?.data?.backSide?.name &&
          this.responseTrialLens?.calculationSection?.data?.backSide?.name?.trim().toLowerCase() === 'sph'.toLowerCase()) {
          newLensFamily = this.responseTrialLens?.copyTrialLens?.article?.lensGroup?.trim();
        }
        lensFamily = this.lensFilter.families.find(lensFamily => lensFamily.name.trim().toLowerCase() === newLensFamily?.toLowerCase());
      } else {
        this.isNeedShowAfterChoice = false;
        this.form.controls['lensFamily'].setValue(lensFamily.name);
      }
    } else {
      lensFamily = this.lensFilter.families.find(lensFamily => lensFamily.name.toLowerCase() === this.form.get('lensFamily').value.toLowerCase());
    }
    // response trial lens with empty family
    if (lensFamily == undefined && copyLensFamily != undefined) {
      lensFamily = copyLensFamily
    }

    if (lensFamily) {
      this.lensFamilyId = lensFamily.id;
      if (lensFamily.name === NONE.name) {
        this.form.get('lensFamily').setValue('');
        this.filteredMaterial = of([]);
      } else {
        this.form.get('lensFamily').setValue(lensFamily.name);
      }
      this.form.get('material').setValue('');
      this.form.get('color').setValue('');
      // save trial lens material if available for family
      if (this.responseTrialLens?.calculationSection?.data?.material) {
        const material = this.responseTrialLens.calculationSection.data.material;
        if (lensFamily.materials.includes(material.id)) {
          this.form.get('material').setValue(material.name);
          this.setMaterial(material);
        }
      }
    } else {
      this.form.get('lensFamily').setValue('');
    }

    this.clearLensDetailsForm();
  }

  setMaterial(copyMaterial?: Material) {
    let material: Material = copyMaterial
      ? copyMaterial
      : this.lensFilter.materials.find(material => material.name === this.form.get('material').value);
    if (material) {
      if (material.defaultColor) {
        this.defaultColor = material.defaultColor;
        this.form.get('color').setValue(material.defaultColor.name);
      } else {
        this.form.get('color').setValue('');
      }
      if (material.name === NONE.name) {
        this.form.get('material').setValue('');
        this.filteredColor = of([]);
      } else {
        const colors: number[] = [].concat(material.colors);
        const updated: Color[] = this.newOrderStoreService.colors.filter((color) => colors.includes(color.id));
        this.filteredColor = of(updated.sort((a, b) => a.name.localeCompare(b.name)));
      }
    } else {
      this.defaultColor = undefined;
      this.form.get('material').setValue('');
      this.form.get('color').setValue('');
    }
  }

  setColor(copyColor?: Color) {
    let color: Color;

    if (copyColor) {
      color = copyColor;
      if (this.copyFinalLens?.color) {
        this.copyFinalLens.color = undefined;
      } else if (this.copyTrialLens?.color) {
        this.copyTrialLens.color = undefined;
      }
    } else {
      color = this.lensFilter.colors.find(color => color.name === this.form.get('color').value);
    }

    if (color) {
      if (color.name === NONE.name) {
        this.form.get('color').setValue('');
        this.filterColors();
      }
    } else {
      this.queryFilter.backSideQuery.colorId = null;
      this.queryFilter.materialQuery.colorId = null;
      this.queryFilter.familyQuery.colorId = null;
      this.form.get('color').setValue('');
    }
  }

  filterPrimaryLists() {
    this.filterBackSides(this.isHard);
    this.filterLensFamilies(this.backSideId);
    this.filterMaterials();
    this.filterColors();
  }

  filterBackSides(isHard: boolean) {
    const backSides = isHard
      ? this.newOrderStoreService.backSides.filter((backSide) => backSide.hard == true)
      : this.newOrderStoreService.backSides.filter((backSide) => backSide.soft == true);
    backSides.sort((a, b) => a.name.localeCompare(b.name));
    this.lensFilter.backSides = backSides;
    this.filteredBackSide = of(backSides);
  }

  filterLensFamilies(backSideId?: number) {
    const lensType: string = ('' + this.form.get('lensType').value).toLowerCase();
    const families = backSideId
      ? this.newOrderStoreService.families.filter(family => family.backSide == backSideId && family.lensType == lensType)
      : this.newOrderStoreService.families.filter(family => family.lensType == lensType);
    families.sort((a, b) => a.name.localeCompare(b.name));
    this.lensFilter.families = families;
    this.filteredLensFamily = of(families);
  }

  filterMaterials() {
    const family: Lens = this.newOrderStoreService.families.find(f => f.name == this.form.get('lensFamily').value);
    const available: number[] = family? [].concat(family.materials) : [];
    const materials = this.newOrderStoreService.materials;
    const updated = materials.filter((material) => available.includes(material.id));
    updated.sort((a, b) => a.name.localeCompare(b.name));
    this.lensFilter.materials = updated;
    this.filteredMaterial = of(updated);
  }

  filterColors() {
    const material: Material = this.newOrderStoreService.materials.find(m => m.name == this.form.get('material').value);
    const available: number[] = material? [].concat(material.colors) : [];
    const updated = this.newOrderStoreService.colors.filter(color => available.includes(color.id));
    updated.sort((a, b) => a.name.localeCompare(b.name));
    this.lensFilter.colors = updated;
    this.filteredColor = of(updated);
  }

  clearQueryFilter() {
    this.queryFilter = {
      backSideQuery: {},
      colorQuery: {},
      materialQuery: {},
      familyQuery: {}
    };
  }

  clearLensFilterForm() {
    this.form.get('backSide').setValue('');
    this.form.get('color').setValue('');
    this.form.get('material').setValue('');
    this.form.get('lensFamily').setValue('');
  }

  clearLensDetailsForm() {
    this.features = {};
    this.additionalOptions.clear();
  }

  clearAll() {
    this.form.reset();
    this.isEditFinalLens = false;
    this.form.controls['lensType'].setValue(LensType.HARD);
    this.clearLensFilterForm();
    this.clearQueryFilter();
    this.clearLensDetailsForm();
    this.getFilters();

    this.clearDesireDate()
  }

  private filterBackSide(value: any) {
    if (value == undefined) value = '';
    if (value) {
      const filterValue = this.normalizeValue(value);
      if (this.lensFilter.backSides) {
        let intermediateBackSides = this.lensFilter.backSides.filter(backSide => this.normalizeValue(backSide.name).includes(filterValue));
        if (!intermediateBackSides.includes(NONE)) {
          intermediateBackSides.unshift(NONE);
        }
        this.filteredBackSide = of(intermediateBackSides);
      }
    }
  }

  private filterLensFamily(value: any) {
    if (value == undefined) value = '';
    if (value) {
      const filterValue = this.normalizeValue(value);
      if (this.lensFilter.families) {
        let intermediateLensFamily = this.lensFilter.families.filter(lensFamily => this.normalizeValue(lensFamily.name).includes(filterValue));
        if (!intermediateLensFamily.includes(NONE)) {
          intermediateLensFamily.unshift(NONE);
        }
        this.filteredLensFamily = of(intermediateLensFamily);
      }
    }
  }

  private filterMaterial(value: any) {
    if (value == undefined) value = '';
    if (value) {
      const filterValue = this.normalizeValue(value);
      if (this.lensFilter.materials) {
        let intermediateMaterial = this.lensFilter.materials.filter(material => this.normalizeValue(material.name).includes(filterValue));
        if (!intermediateMaterial.includes(NONE)) {
          intermediateMaterial.unshift(NONE);
        }
        this.filteredMaterial = of(intermediateMaterial);
      }
    }
  }

  private filterColor(value: any) {
    if (value == undefined) value = '';
    if (value) {
      const filterValue = this.normalizeValue(value);
      if (this.lensFilter.colors) {
        let intermediateColor = this.lensFilter.colors.filter(color => this.normalizeValue(color.name).includes(filterValue));
        if (!intermediateColor.includes(NONE)) {
          intermediateColor.unshift(NONE);
        }
        this.filteredColor = of(intermediateColor);
      }
    }
  }

  private normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  private extractFeatureValue(feature: LensFeature): string {
    return this.i18nService.formatIfNumber((feature as FixedFeature).value);
  }

  getLimitsFormatted(rangeMin: number, rangeMax: number) {
    return this.i18nService.getLimitsFormatted(rangeMin, rangeMax);
  }

  getTranslation(feature: any) {
    return this.catalogService.getFeatureTranslation(feature.name);
  }

  getHintTranslation(feature: any) {
    return this.catalogService.getFeatureHintTranslation(feature.name);
  }

  copy(side: LensSide) {
    this.copyEmit.emit(side);
  }

  switch(side: LensSide) {
    this.switchEmit.emit(side);
  }

  toEnumFeature(feature: LensFeature): EnumFeature {
    return feature as EnumFeature;
  }

  setValueWithFormat(featureName: string) {
    this.lensDetailsForm.controls[featureName].setValue(
      this.i18nService.replaceFromDotToComma(
        this.i18nService.formatIfNumber(this.lensDetailsForm.controls[featureName].value, this.globalStorageService.decimalFormats.find(feature => feature.featureName === featureName)?.decimalFormat)
      )
    );
    this.additionalOptions.set(featureName, this.lensDetailsForm.controls[featureName].value);

    if ("Prism" == featureName) {
      this.calculateProductionDate();
    }
  }

  initFeaturesState() {
    let hasNonRequired: boolean = false;
    if (this.features.default) {
      this.features.default.forEach(feature => {
        if (!feature.required) {
          let key = Object.keys(this.lensDetailsForm.controls).find(key => key === feature.name);
          if (this.lensDetailsForm.controls[key].value !== "") {
            hasNonRequired = true;
          }
        }
      });
    }
    this.showAdditionalOptions = hasNonRequired;
  }

  toggleFeatures() {
    this.showAdditionalOptions = !this.showAdditionalOptions;
  }

  initDateFilter() {
    this.minDate = new Date();
    let offDays: Date[] = [];
    this.newOrderStoreService.offDays.forEach(function (offDay) {
      let date: Date = new Date(offDay.year, offDay.month - 1, offDay.day);
      offDays.push(date);
    });

    this.dateFilter = (d: Date): boolean => {
      if (d) {
        const time = d.getTime();
        const day = d.getDay();
        return day !== 0 && day !== 6 && !offDays.find(x => x.getTime() == time) && d > this.minDate;
      }
    };
  }

  clearDesireDate() {
    this.desireDate = null;
  }

  checkProductionDateVariables() {
    return this.form.controls['lensFamily'].value != '' && this.form.controls['material'].value != '';
  }

  calculateProductionDate() {
    const start = performance.now();
    if (this.checkProductionDateVariables()) {
      let family = this.form.controls['lensFamily'].value;
      let material = this.form.controls['material'].value;
      let prism = this.lensDetailsForm.contains('Prism') ? this.lensDetailsForm.controls['Prism'].value : '';
      this.manufactureApiService.calculate([family, material, prism]).subscribe(response => {
        this.minDate = new Date(response.body.year, response.body.month - 1, response.body.day, 12);
        if (this.desireDate) {
          this.desireDate = new Date(this.desireDate);
          if (this.desireDate.getTime() < this.minDate.getTime()) {
            this.desireDate.setTime(this.minDate.getTime());
            this.messageService.orange("newOrder.finalLens.desireDateChange");
          }
        }
        const end = performance.now();
        console.log('calculateProductionDate', end - start);
      });
    }
  }

  checkDesireDate() {
    let accept: string[] = ['101', '1073000', '1009999', '1041906', '1080044', '107923', '1000028', '1014922', '1072934', '1079234'];
    this.showDesireDate = accept.includes(this.currentUser.account.customerNumber);
  }

  nextInput(target: string) {
    const prefix = target.split('#')[0];
    const suffix = target.split('#')[1];
    let id = Number(suffix) + 1;
    const first = document.getElementById(prefix + '#' + 0) as HTMLInputElement;
    const next = document.getElementById(prefix + '#' + id) as HTMLInputElement;
    next ? next.focus() : first.focus();
  }
}

const NONE = {
  id: null,
  name: 'None'
};
